<script lang="ts">
    import {onMount} from "svelte";
    import DialogView from "../../../../../component/common/Dialog/DialogView.svelte";
    import ButtonView from "../../../../../component/common/Button/ButtonView.svelte";
    import PortalView from "../../../../../component/common/Portal/PortalView.svelte";
    import TabView from "../../../../../component/common/Tab/TabView.svelte";
    import BinaryApiHelpUploadTabContentView from "./BinaryApiHelpUploadTabContentView.svelte";
    import BinaryApiHelpDownloadTabContentView from "./BinaryApiHelpDownloadTabContentView.svelte";


    onMount(() => {
    });

    let isShowDescription = false;

    function onClickShowDescription() {
        isShowDescription = true;
    }

</script>

<div class="binary-api-help-view">
    <div class="description">
        <div>
            Jenkins などの CI環境からバイナリファイルをアップロードしたり、
        </div>
        <div>
            ダウンロードすることができます。
        </div>

    </div>

    <div>
        <ButtonView text="バイナリファイルAPIの説明を開く" fontAwesomeIcon="circle-info" on:click={onClickShowDescription}/>
    </div>

</div>

<PortalView>

    <DialogView title="バイナリファイルAPIの説明" isShow={isShowDescription} on:close={()=>{isShowDescription = false;}}>
        <div class="dialog-content">

            <TabView let:activeTabName minHeight="80vh">
                <BinaryApiHelpUploadTabContentView activeTabName={activeTabName}/>
                <BinaryApiHelpDownloadTabContentView activeTabName={activeTabName}/>

            </TabView>


        </div>
    </DialogView>

</PortalView>

<style lang="scss">
    .binary-api-help-view {
        border-style: solid;
        border-width: 1px;
        border-radius: 8px;
        border-color: #0003;
        padding: 16px;
        font-size: 0.75em;

        display: flex;
        flex-direction: column;
        gap: 8px;

        .url {

        }

        .param-area {
            font-size: 0.75em;
        }
    }

    .dialog-content {

    }
</style>